import React, { Component } from 'react';
import { TIMETABLE_PATH } from '../../../constants/routes';
import { storeLastEvent } from '../../../services/local.storage';
import SelectField from '../../forms/SelectField';

class FestivalTitle extends Component {
    constructor(props) {
        super(props);
        this.state = { menuOpen: false };
    }

    _openMenu = () => {
        if (this.props.events && this.props.events.length) {
            this.setState({ menuOpen: true });
        }
    };
    _closeMenu = () => {
        this.setState({ menuOpen: false });
    };
    _onEventSelect = value => {
        value && (window.location.href = TIMETABLE_PATH.replace(':id', value));
    };

    componentDidUpdate() {
        if (this.props.selectedEvent) {
            storeLastEvent(this.props.selectedEvent);
        }
    }

    render() {
        return (
            <div className="ckp-timetable-title rp-hidden-760-min">
                <h1
                    className={`ckp-ts-h1-a ckp-timetable-title-label ${
                        this.props.events && this.props.events.length ? '' : 'is-not-a-menu'
                    } ${this.state.menuOpen ? 'is-open' : ''}`}
                    onClick={this._openMenu}
                >
                    {this.props.title}
                </h1>
                <div className="ckp-timetable-title-select">
                    <SelectField
                        items={this.props.events || []}
                        onChange={this._onEventSelect}
                        open={this.state.menuOpen}
                        onOpen={this._openMenu}
                        onClose={this._closeMenu}
                        disableUnderline={true}
                        IconComponent={() => null}
                        displayEmpty={true}
                        MenuProps={{
                            anchorOrigin: {
                                vertical: 'bottom',
                                horizontal: 'center'
                            },
                            transformOrigin: {
                                vertical: 'top',
                                horizontal: 'center'
                            },
                            getContentAnchorEl: null,
                            PaperProps: {
                                style: {
                                    marginTop: '8px'
                                }
                            }
                        }}
                    />
                </div>
            </div>
        );
    }
}

export default FestivalTitle;
